import React, { useRef } from 'react';
import PEHeroSection from '../../../components/landingPage/PEPage/PEHeroSection';
import PEWhySection from '../../../components/landingPage/PEPage/PEWhySection';
import PEQuotesSection from '../../../components/landingPage/PEPage/PEQuotesSection';
import PECtaSection from '../../../components/landingPage/PEPage/PECtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';

const LandingHomePEs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);

    return (
        <div className="lp-page" ref={rootRef}>
            <PEHeroSection />
            <PEWhySection />
            <PEQuotesSection />
            <PECtaSection />
        </div>
    );
};

export default LandingHomePEs;
